// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5da35ccd","239":"1f21036b","455":"abd2615f","762":"523f3c99"}[chunkId] + ".chunk.js";
};